import type { FunctionComponent } from "react";
import FixedPayoutsAdminPartial from "../../../partials/admin/fixed-payouts/fixed-payouts.admin.partials";

export const FixedPayoutsAdminScreen: FunctionComponent = () => {
	return <FixedPayoutsAdminPartial/>;
};
